import { Icon } from "@iconify/react/dist/iconify.js";
import { useState } from "react";
import { MenuStores } from "./MenuStores";
import { useSelector } from "react-redux";
import { getStoreId, getStores } from "../redux/selectors";

export const Contacts = ({ position }) => {
  const storeId = useSelector(getStoreId) || "682b89f4c28a3e5c9c0ce408";
  const stores = useSelector(getStores);
  const storeSelected = stores.find((s) => s._id === storeId);

  const contactsList = storeSelected
    ? storeSelected?.contacts.slice(0, 2)
    : null;
  const [storeOpen, setStoreOpen] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
    setStoreOpen(true);
  };
  const handleClose = () => {
    setAnchorEl(null);
    setStoreOpen(false);
  };

  return (
    <>
      <ul
        className={`${
          position === "menu"
            ? "md:hidden flex flex-col items-st text-sm whitespace-nowrap px-3"
            : ""
        } ${
          position === "footer"
            ? "bg-transparent flex flex-col pl-6 md:pl-10 items-start"
            : "bg-bluredBlack"
        } ${
          position === "top"
            ? "hidden sm:flex justify-center gap-20 xl:hidden w-full mx-auto"
            : position === "menu"
            ? "flex"
            : "hidden xl:block"
        }  p-1 xl:bg-transparent `}
      >
        <div
          onClick={(e) => handleClick(e)}
          className="flex items-center justify-center xl:text-mainWhite  xl:hover:text-mainGreen hover:text-mainGreen text-mainBlack font-semibold text-lg cursor-pointer"
        >
          <span className="">Multicook {storeSelected.title}</span>
          <Icon icon="icon-park-solid:down-one" className="text-2xl ml-2 " />
        </div>
        {contactsList.map((el) => (
          <li
            key={el.id}
            className={position === "footer" ? "py-1 md:py-2 md:mr-10" : ""}
          >
            <a
              href={el.link}
              target={"_blank"}
              rel={"noopener noreferrer"}
              className={`flex items-center lg:text-xl xl:text-base font-semibold justify-center md:justify-start ${
                position === "footer"
                  ? "hover:text-bluredBlack md:text-lg"
                  : "hover:text-mainGreen"
              }  pt-1 md:py-1`}
            >
              {position !== "menu" && (
                <Icon
                  icon={el.icon}
                  className={`text-2xl mr-2 text-black ${
                    position === "menu" && "text-xl"
                  }`}
                />
              )}
              <p>{el.description}</p>
            </a>
          </li>
        ))}
      </ul>
      <MenuStores
        anchorEl={anchorEl}
        open={storeOpen}
        handleClose={handleClose}
      />
    </>
  );
};
